export function orderModalToDetailProps(data: any) {
  return {
    id: data.id,
    address: data.address || '',
    addressDetails: data.address_details || '',
    status: data.status || '',
    date: data.created_at || data.date || '',
    amount: data.amount || 0,
    commission: data.commission || 0,
    description: data.description || '',
    shortDescription: data.short_description,
    category: data.category || data.category_name || '',
    rating: data.rating,
    review: data.review,
    client: data.client,
    performer: data.performer,
    latitude: data.latitude,
    longitude: data.longitude,
    photos: data.photos,
    expiration_time: data.expiration_time,
    original_validity_minutes: data.original_validity_minutes,
    is_expired: data.is_expired,
    renewed_at: data.renewed_at,
    remaining_time_seconds: data.remaining_time_seconds,
    funds_blocked: data.funds_blocked,
    funds_distributed: data.funds_distributed,
    block_transaction_id: data.block_transaction_id,
    distribute_transaction_id: data.distribute_transaction_id,
    blocked_at: data.blocked_at,
    distributed_at: data.distributed_at,
    created_at: data.created_at,
    assigned_at: data.assigned_at,
    work_started_at: data.work_started_at,
    work_completed_at: data.work_completed_at,
    auto_confirmed_at: data.auto_confirmed_at,
    status_timeout_applied: data.status_timeout_applied,
    cancellation_reason: data.cancellation_reason,
    cancellation_commission_rate: data.cancellation_commission_rate,
    cancellation_commission_amount: data.cancellation_commission_amount,
    closed_by_customer: data.closed_by_customer,
    responses_count: data.responses_count,
  };
}
